import {
  FETCH_ALL_COUNTRIES,
  FETCH_ALL_COUNTRIES_SUCCESS,
  FETCH_SONGS,
  FETCH_SONGS_SUCCESS,
  CREATE_SONG,
  CREATE_SONG_SUCCESS,
  RESTORE_CREATE_SONG_INITIAL,
  EDIT_SONG,
  EDIT_SONG_SUCCESS,
  RESTORE_EDIT_SONG_INITIAL,
  DELETE_SONG,
  DELETE_SONG_SUCCESS,
  RESTORE_DELETE_SONG_INITIAL,
  FETCH_SONG_BY_ID,
  FETCH_SONG_BY_ID_SUCCESS,
  FETCH_ALL_BANNERS,
  FETCH_ALL_BANNERS_SUCCESS,
  FETCH_BANNER_BY_ID,
  FETCH_BANNER_BY_ID_SUCCESS,
  UPDATE_BANNER,
  UPDATE_BANNER_SUCCESS,
  RESTORE_UPDATE_BANNER_INITIAL,
  CREATE_BANNER,
  CREATE_BANNER_SUCCESS,
  RESTORE_CREATE_BANNER_INITIAL,
  DELETE_BANNER,
  DELETE_BANNER_SUCCESS,
  RESTORE_DELETE_BANNER_INITIAL,
  FETCH_ALL_PROMPT,
  FETCH_ALL_PROMPT_SUCCESS,
  FETCH_PROMPT_BY_ID,
  FETCH_PROMPT_BY_ID_SUCCESS,
  CREATE_PROMPT,
  CREATE_PROMPT_SUCCESS,
  RESTORE_CREATE_PROMPT_INITIAL,
  UPDATE_PROMPT,
  UPDATE_PROMPT_SUCCESS,
  RESTORE_UPDATE_PROMPT_INITIAL,
  DELETE_PROMPT,
  DELETE_PROMPT_SUCCESS,
  RESTORE_DELETE_PROMPT_INITIAL,
} from "../ActionTypes";

export const fetchCountries = () => ({
  type: FETCH_ALL_COUNTRIES,
});

export const fetchCountriesSuccess = (payload) => ({
  type: FETCH_ALL_COUNTRIES_SUCCESS,
  payload,
});

export const fetchSongs = () => ({
  type: FETCH_SONGS,
});

export const fetchSongsSuccess = (payload) => ({
  type: FETCH_SONGS_SUCCESS,
  payload,
});

export const addSong = (payload) => ({
  type: CREATE_SONG,
  payload,
});

export const addSongSuccess = (payload) => ({
  type: CREATE_SONG_SUCCESS,
  payload,
});

export const restoreAddSongInitial = () => ({
  type: RESTORE_CREATE_SONG_INITIAL,
});

export const editSong = ({ formData, songId }) => ({
  type: EDIT_SONG,
  payload: {
    formData,
    songId,
  },
});

export const editSongSuccess = (payload) => ({
  type: EDIT_SONG_SUCCESS,
  payload,
});

export const restoreEditSongInitial = () => ({
  type: RESTORE_EDIT_SONG_INITIAL,
});

export const deleteSong = (id) => ({
  type: DELETE_SONG,
  payload: id,
});

export const deleteSongSuccess = (payload) => ({
  type: DELETE_SONG_SUCCESS,
  payload,
});

export const restoreDeleteSongInitial = () => ({
  type: RESTORE_DELETE_SONG_INITIAL,
});

export const fetchSongById = (id) => ({
  type: FETCH_SONG_BY_ID,
  payload: id,
});

export const fetchSongByIdSuccess = (payload) => ({
  type: FETCH_SONG_BY_ID_SUCCESS,
  payload,
});

export const fetchAllBanners = () => ({
  type: FETCH_ALL_BANNERS,
});

export const fetchAllBannersSuccess = (payload) => ({
  type: FETCH_ALL_BANNERS_SUCCESS,
  payload,
});

export const fetchBannerById = (id) => ({
  type: FETCH_BANNER_BY_ID,
  payload: id,
});

export const fetchBannerByIdSuccess = (payload) => ({
  type: FETCH_BANNER_BY_ID_SUCCESS,
  payload,
});

export const addBanner = (payload) => ({
  type: CREATE_BANNER,
  payload,
});

export const addBannerSuccess = (payload) => ({
  type: CREATE_BANNER_SUCCESS,
  payload,
});

export const restoreAddBannerInitial = () => ({
  type: RESTORE_CREATE_BANNER_INITIAL,
});

export const editBanner = ({ formData, bannerId }) => ({
  type: UPDATE_BANNER,
  payload: {
    formData,
    bannerId,
  },
});

export const editBannerSuccess = (payload) => ({
  type: UPDATE_BANNER_SUCCESS,
  payload,
});

export const restoreEditBannerInitial = () => ({
  type: RESTORE_UPDATE_BANNER_INITIAL,
});

export const deleteBanner = (id) => ({
  type: DELETE_BANNER,
  payload: id,
});

export const deleteBannerSuccess = (payload) => ({
  type: DELETE_BANNER_SUCCESS,
  payload,
});

export const restoreDeleteBannerInitial = () => ({
  type: RESTORE_DELETE_BANNER_INITIAL,
});

export const fetchAllPrompt = () => ({
  type: FETCH_ALL_PROMPT,
});

export const fetchAllPromptSuccess = (payload) => ({
  type: FETCH_ALL_PROMPT_SUCCESS,
  payload,
});

export const fetchPromptById = (id) => ({
  type: FETCH_PROMPT_BY_ID,
  payload: id,
});

export const fetchPromptByIdSuccess = (payload) => ({
  type: FETCH_PROMPT_BY_ID_SUCCESS,
  payload,
});

export const addPrompt = ({ prompt, prompt_url }) => ({
  type: CREATE_PROMPT,
  payload: {
    prompt,
    prompt_url,
  },
});

export const addPromptSuccess = (payload) => ({
  type: CREATE_PROMPT_SUCCESS,
  payload,
});

export const restoreAddPromptInitial = () => ({
  type: RESTORE_CREATE_PROMPT_INITIAL,
});

export const editPrompt = ({ prompt, prompt_url, id }) => ({
  type: UPDATE_PROMPT,
  payload: {
    prompt,
    prompt_url,
    id,
  },
});

export const editPromptSuccess = (payload) => ({
  type: UPDATE_PROMPT_SUCCESS,
  payload,
});

export const restoreEditPromptInitial = () => ({
  type: RESTORE_UPDATE_PROMPT_INITIAL,
});

export const deletePrompt = (id) => ({
  type: DELETE_PROMPT,
  payload: id,
});

export const deletePromptSuccess = (payload) => ({
  type: DELETE_PROMPT_SUCCESS,
  payload,
});

export const restoreDeletePromptInitial = () => ({
  type: RESTORE_DELETE_PROMPT_INITIAL,
});
